import { render, staticRenderFns } from "./DeviceItem.vue?vue&type=template&id=3631517c&scoped=true&"
import script from "./DeviceItem.vue?vue&type=script&lang=js&"
export * from "./DeviceItem.vue?vue&type=script&lang=js&"
import style0 from "./DeviceItem.vue?vue&type=style&index=0&id=3631517c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631517c",
  null
  
)

export default component.exports